import { useEffect, useState } from 'react';

// A phone held sideways: short, touch-driven, and wider than it is tall.
// Height (not width) is what matters here — landscape phones are 667–932px
// wide, so they land on both sides of the app's 768px (md:) breakpoint and
// would otherwise get the phone or desktop layout depending on the model.
// Tablets stay out because they're taller than 500px in landscape.
export const COMPACT_LANDSCAPE_QUERY = '(orientation: landscape) and (max-height: 500px) and (pointer: coarse)';

// Tracks whether the compact-landscape layout (left nav rail instead of the
// top masthead) should be used. Updates live on rotation.
function useCompactLandscape() {
    const [isCompactLandscape, setIsCompactLandscape] = useState(() => (
        typeof window !== 'undefined' && typeof window.matchMedia === 'function'
            ? window.matchMedia(COMPACT_LANDSCAPE_QUERY).matches
            : false
    ));

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

        const mediaQueryList = window.matchMedia(COMPACT_LANDSCAPE_QUERY);
        const handleChange = (event) => setIsCompactLandscape(event.matches);
        setIsCompactLandscape(mediaQueryList.matches);

        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener('change', handleChange);
            return () => mediaQueryList.removeEventListener('change', handleChange);
        }
        // Safari < 14 fallback
        mediaQueryList.addListener(handleChange);
        return () => mediaQueryList.removeListener(handleChange);
    }, []);

    return isCompactLandscape;
}

export default useCompactLandscape;
